import { Component, Inject, Input, Optional } from '@angular/core';
import { CountryCode, YOUR_ASSORTMENT, YOUR_ASSORTMENT_EXTERNAL } from '~shared/constants';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

@Component({
  selector: 'app-subsidiary-alert',
  templateUrl: './subsidiary-alert.component.html',
  styleUrls: ['./subsidiary-alert.component.scss'],
})
export class SubsidiaryAlertComponent {
  @Input()
  isSubsidiaryAccount: boolean;
  @Input()
  organizationName: string;
  @Input()
  isMobileOrTablet: boolean;
  hideSubsidiaryAccountAlertTitle: boolean;
  subsidiaryTitleHideList = [CountryCode.Spain, CountryCode.Italy];

  public readonly shoppingListLink: string = YOUR_ASSORTMENT_EXTERNAL();

  constructor(@Optional() @Inject(REQUEST) private webAppBuyerRequest: any) {}

  ngOnInit() {
    const market = getCountryDomainCode(this.webAppBuyerRequest);
    this.hideSubsidiaryAccountAlertTitle = this.subsidiaryTitleHideList.includes(market);
  }
}
